<template>
	<div ref="infiniteHandler">
		<button v-if="showButton" class="round-button" @click="handleButtonClick">{{ buttonText }}</button>
	</div>
</template>

<script>
	export default {
		props: {
			listening: {
				type: Boolean,
				default: true
			},
			showButton: {
				type: Boolean,
				default: false
			},
			buttonText: {
				type: String,
				default: 'Load More ...'
			}
		},
		methods: {
			listen () {
				window.addEventListener('scroll', this.handleScroll)
			},
			turnAway () {
				window.removeEventListener('scroll', this.handleScroll)
			},
			handleScroll () {
				if (this.isInViewport(this.$refs.infiniteHandler)) {
					this.$emit('fetch')
				}
			},
			handleButtonClick () {
				this.$emit('fetch')
			},
			isInViewport (e) {
			    var bounding = e.getBoundingClientRect()
			    var documentHeight = window.innerHeight ||
			    	document.documentElement.scrollHeight ||
				 	document.documentElement.offsetHeight ||
				 	document.documentElement.clientHeight
			    var documentWidth = window.innerWidth ||
			    	document.documentElement.scrollWidth ||
				    document.documentElement.offsetWidth ||
				    document.documentElement.clientWidth
			    // var documentHeight = window.innerHeight || document.documentElement.clientHeight
			    // var documentWidth = window.innerWidth || document.documentElement.clientWidth

			    return (
			        bounding.top >= 0 &&
			        bounding.left >= 0 &&
			        (bounding.bottom - (documentHeight * .4)) <= documentHeight &&
			        bounding.right <= documentWidth
			    )
			    /*
			    return (
			        bounding.top >= 0 &&
			        bounding.left >= 0 &&
			        (bounding.bottom - ((window.innerHeight || document.documentElement.clientHeight) * .75)) <= (window.innerHeight || document.documentElement.clientHeight) &&
			        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
			    )
			    */
			}
		},
		mounted () {
			this.$nextTick(() => {
				if (this.listening) {
					this.handleScroll()
				}
			})
		},
		destroyed () {
			this.turnAway()
		},
		watch: {
			listening (value) {
				if (value) {
					this.handleScroll()
					this.listen()
				} else {
					this.turnAway()
				}
			}
		}
	}
</script>